// path: src/Components/row/Row.js
import React, { useEffect, useRef, useState } from "react";
import Card from "@material-ui/core/Card";
import "./row.css";

const Row = (card) => {
    const delayMs = (card.index ?? 0) * 70; // tweak if you want
    const [animateIn, setAnimateIn] = useState(true);
    const lastLevelKeyRef = useRef(card.levelKey);

    useEffect(() => {
    // Animate on first mount, and again only if the level changes
    if (lastLevelKeyRef.current !== card.levelKey) {
        lastLevelKeyRef.current = card.levelKey;
        setAnimateIn(true);
    }

    // Turn the class off after it runs so shuffles/rerenders don’t accidentally retrigger
    const t = setTimeout(() => setAnimateIn(false), 900);
    return () => clearTimeout(t);
    }, [card.levelKey]);

    return (
    <Card
        raised={true}
        className={`card ${animateIn ? "card--cinematicEnter" : ""}`}
        style={animateIn ? { animationDelay: `${delayMs}ms` } : undefined}
    >
        <div className="cardFlip">
        <div className="cardFlipInner">
            <div className="cardFlipBack" aria-hidden="true" />
            <img
            src={`imgs/${card.image}`}
            alt={card.name}
            className="card-image cardFlipFront"
            onClick={card.handleClick}
            id={card.id}
            />
        </div>
        </div>
    </Card>
    );
};

export default Row;